<template>
    <div class="filtro-periodo" role="group" aria-label="Filtro de período">
        <div class="campo" :class="{ aberto: mesAberto }" ref="campoMes">
            <button
                type="button"
                class="campo-trigger"
                :aria-expanded="mesAberto"
                aria-haspopup="listbox"
                @click="toggleMes"
            >
                <span class="campo-label">Mês</span>
                <span class="campo-valor">
                    {{ rotuloMes }}
                    <i class="bi bi-chevron-down" aria-hidden="true"></i>
                </span>
            </button>
            <ul v-if="mesAberto" class="campo-lista" role="listbox">
                <li>
                    <button
                        type="button"
                        role="option"
                        :aria-selected="mes === null"
                        :class="{ ativo: mes === null }"
                        @click="escolherMes(null)"
                    >
                        Ano inteiro
                    </button>
                </li>
                <li v-for="i in mesesEanos.meses" :key="i.id">
                    <button
                        type="button"
                        role="option"
                        :aria-selected="mes === i.id"
                        :class="{ ativo: mes === i.id }"
                        @click="escolherMes(i.id)"
                    >
                        {{ i.nome }}
                    </button>
                </li>
            </ul>
        </div>

        <div class="campo campo-destaque" :class="{ aberto: anoAberto }" ref="campoAno">
            <button
                type="button"
                class="campo-trigger"
                :aria-expanded="anoAberto"
                aria-haspopup="listbox"
                @click="toggleAno"
            >
                <span class="campo-label">Período ativo</span>
                <span class="campo-valor">
                    {{ ano }}
                    <i class="bi bi-chevron-down" aria-hidden="true"></i>
                </span>
            </button>
            <ul v-if="anoAberto" class="campo-lista" role="listbox">
                <li v-for="anoOption in mesesEanos.anos" :key="anoOption">
                    <button
                        type="button"
                        role="option"
                        :aria-selected="ano === anoOption"
                        :class="{ ativo: ano === anoOption }"
                        @click="escolherAno(anoOption)"
                    >
                        {{ anoOption }}
                    </button>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import serviceGraficos from '@/services/serviceGraficos.js';

export default {
    name: 'HeaderSelecaoMeses',
    props: {
        mes: {
            type: [Number, null],
            default: null,
        },
        ano: {
            type: Number,
            default: () => new Date().getFullYear(),
        },
    },
    emits: ['updateMes', 'updateAno'],
    data() {
        return {
            mesesEanos: serviceGraficos.getMesEano(),
            mesAberto: false,
            anoAberto: false,
        };
    },
    computed: {
        rotuloMes() {
            if (this.mes == null) return 'Ano inteiro';
            return this.mesesEanos.meses.find((m) => m.id === this.mes)?.nome || 'Ano inteiro';
        },
    },
    mounted() {
        document.addEventListener('click', this.onClickFora);
    },
    beforeUnmount() {
        document.removeEventListener('click', this.onClickFora);
    },
    methods: {
        toggleMes() {
            this.mesAberto = !this.mesAberto;
            this.anoAberto = false;
        },
        toggleAno() {
            this.anoAberto = !this.anoAberto;
            this.mesAberto = false;
        },
        escolherMes(mes) {
            this.$emit('updateMes', mes);
            this.mesAberto = false;
        },
        escolherAno(ano) {
            this.$emit('updateAno', ano);
            this.anoAberto = false;
        },
        onClickFora(event) {
            const mesEl = this.$refs.campoMes;
            const anoEl = this.$refs.campoAno;
            if (mesEl && !mesEl.contains(event.target)) this.mesAberto = false;
            if (anoEl && !anoEl.contains(event.target)) this.anoAberto = false;
        },
    },
};
</script>

<style scoped>
.filtro-periodo {
    display: flex;
    align-items: stretch;
    gap: 0.65rem;
    flex-shrink: 0;
}

.campo {
    position: relative;
    min-width: 10.5rem;
    border-radius: 12px;
    background: var(--cor-bg);
    box-shadow:
        0 0 0 1px rgba(0, 0, 0, 0.06),
        0 4px 12px rgba(0, 0, 0, 0.08),
        0 12px 28px rgba(0, 0, 0, 0.12);
}

.campo-destaque {
    background: #e8f0fb;
    box-shadow:
        0 0 0 1px var(--cor-primaria-media),
        0 4px 12px rgba(53, 113, 205, 0.12),
        0 12px 28px rgba(0, 0, 0, 0.12);
}

html.dark .campo-destaque,
.dark .campo-destaque {
    background: rgba(53, 113, 205, 0.28);
}

.campo.aberto {
    box-shadow:
        0 0 0 1px var(--cor-primaria-media),
        0 6px 16px rgba(0, 0, 0, 0.12),
        0 16px 32px rgba(0, 0, 0, 0.14);
    z-index: 5;
}

.campo-trigger {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.15rem;
    width: 100%;
    padding: 0.5rem 0.8rem;
    border: none;
    border-radius: 12px;
    background: transparent;
    cursor: pointer;
    text-align: left;
    color: inherit;
}

.campo-label {
    font-size: 0.68rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    opacity: 0.7;
}

.campo-destaque .campo-label {
    color: var(--cor-primaria-forte);
    opacity: 0.85;
}

.campo-valor {
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.6rem;
    width: 100%;
    font-size: 0.95rem;
    font-weight: 600;
    line-height: 1.2;
}

.campo-destaque .campo-valor {
    color: var(--cor-primaria-forte);
    font-size: 1rem;
    font-weight: 700;
}

.campo-valor i {
    font-size: 0.8rem;
    opacity: 0.7;
    transition: transform 0.15s ease;
}

.campo.aberto .campo-valor i {
    transform: rotate(180deg);
}

.campo-lista {
    position: absolute;
    top: auto;
    bottom: calc(100% + 0.35rem);
    left: 0;
    right: 0;
    z-index: 30;
    margin: 0;
    padding: 0.35rem;
    list-style: none;
    max-height: 16rem;
    overflow-y: auto;
    border-radius: 12px;
    background: var(--cor-bg);
    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.12), 0 0 0 1px var(--cor-separador);
}

.campo-lista button {
    display: block;
    width: 100%;
    padding: 0.55rem 0.7rem;
    border: none;
    border-radius: 8px;
    background: transparent;
    text-align: left;
    cursor: pointer;
    color: inherit;
    font-size: 0.9rem;
}

.campo-lista button:hover {
    background: var(--cor-primaria-fraca);
}

.campo-lista button.ativo {
    background: var(--cor-primaria);
    color: #fff;
    font-weight: 600;
}

@media (max-width: 720px) {
    .filtro-periodo {
        width: 100%;
    }

    .campo {
        flex: 1;
        min-width: 0;
    }
}
</style>
